<template>
  <div class="SDWAN">
    <div class="the-banner"></div>
    <div class="bgbox-gray">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="module-title">
          <span>神行者 • 2019湖南SD-WAN峰会</span>
        </div>
        <div class="module1-conts">
          <p>2019湖南SD-WAN峰会吸引了多位行业领导及百余位企业代表参加，会议现场人头攒动，气氛活跃，大会以“自由组网、安全速达”为主题，深入分析了SD-WAN市场痛点、技术原理及解决方案等，为推动湖南SD-WAN产业的加速发展，建立湖南SD-WAN发展交流圈做出了重要贡献。</p>
          <div class="img-list">
            <el-row :gutter="20">
              <el-col :xs="{span:24}" :sm="{span:8}" :md="{span:8}" :lg="{span:9}">
                <div class="img-item">
                  <img :src="require('@/assets/images/sdwan-module1-1.png')" />
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:8}" :md="{span:8}" :lg="{span:9}">
                <div class="img-item">
                  <img :src="require('@/assets/images/sdwan-module1-2.png')" />
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:8}" :md="{span:8}" :lg="{span:6}">
                <div class="img-item">
                  <img :src="require('@/assets/images/sdwan-module1-3.png')" />
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:8}" :md="{span:8}" :lg="{span:6}">
                <div class="img-item">
                  <img :src="require('@/assets/images/sdwan-module1-4.png')" />
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:8}" :md="{span:8}" :lg="{span:9}">
                <div class="img-item">
                  <img :src="require('@/assets/images/sdwan-module1-5.png')" />
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:8}" :md="{span:8}" :lg="{span:9}">
                <div class="img-item">
                  <img :src="require('@/assets/images/sdwan-module1-6.png')" />
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </div>
    <div class="bgbox-white">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="module-title">
          <span>SD-WAN的概念及市场</span>
        </div>
        <div class="module2-conts">
          <p class="line1">① SD-WAN ( 软件定义广域网：Software Define-WAN )</p>
          <p class="line2">资源通过可编程的方式进行创建、管理与分配。并通过路径优化提升网络安全性、稳定性，是一种旨在帮助用户降低广域网（WAN）的开支和提高网络连接灵活性的新兴技术。</p>
          <p class="line1">② SD-WAN的市场前景 ( 市场新需求，科技新焦点 )</p>
          <div class="card-list">
            <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:6}" :lg="{span:6}">
              <div class="item">
                <div class="card">
                  <div class="card-header">“市场状况”</div>
                  <div class="card-body">
                    <p>传统VPN价格便宜，效果一般；运营商MPLS专线效果好，价格昂贵，中国网络，互联不互通。</p>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:6}" :lg="{span:6}">
              <div class="item">
                <div class="card">
                  <div class="card-header">“新的需求”</div>
                  <div class="card-body">
                    <p>传统的VPN和MPLS组网已经不能满足企业对于快速组网、灵活调配的业务需求。</p>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:6}" :lg="{span:6}">
              <div class="item">
                <div class="card">
                  <div class="card-header">“变化的环境”</div>
                  <div class="card-body">
                    <p>一带一路的政策下，越来越多的企业开辟海外市场；网络通讯以及IT系统变得不可或缺，要求其更快速、更稳定、更安全。</p>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:6}" :lg="{span:6}">
              <div class="item">
                <div class="card">
                  <div class="card-header">“SD-WAN来了”</div>
                  <div class="card-body">
                    <p>SD-WAN是集企业级VPN的性价比和MPLS专线的实际效果为一体的“中间型”产品。</p>
                  </div>
                </div>
              </div>
            </el-col>
          </div>
          <div class="img-view">
            <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:12}">
              <img class="module2-img" :src="require('@/assets/images/sdwan-module2-1.jpg')" />
            </el-col>
            <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:12}">
              <img class="module2-img" :src="require('@/assets/images/sdwan-module2-2.jpg')" />
            </el-col>
          </div>
        </div>
      </el-col>
    </div>
    <div class="bgbox-gray">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="module-title">
          <span>神行者SD-WAN解决方案概述</span>
        </div>
        <div class="module3-conts">
          <p>神行者SD-WAN以网络即服务(NaaS)和安全即服务(SaaS)的 方式，为<span>多分支机构、数据中心互联、混合云</span>等场景的用户提供广域安全组网方案。</p>
          <p>同时，神行者SD-WAN解决网络运维成本高、广域组网复杂等网络问题，同时针对广域网及内网数据日益严重的安全风险，提供“端-网- 云”一体的内生安全防护能力,并提供四种加密方式AES-128、AES-192、AES-256、SM4。通过灵活便捷、按需定制的网络连接，弹性部署的安全能力，数据驱动的网络及安全策略决策支持，让<span>网络更安全, 让安全更智能</span>。</p>
          <div class="img-box">
            <img :src="require('@/assets/images/sdwan-module3-1.png')" />
          </div>
        </div>
      </el-col>
    </div>
    <div class="bgbox-white">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="module-title">
          <span>3种架构优势对比</span>
        </div>
        <div class="module4-conts">
          <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:24}" :lg="{span:8}">
            <div class="module4-item wow slideInLeft">
              <div class="conts">
                <div class="title">
                  <img :src="require('@/assets/images/sdwan-module4-1.png')" />
                  <span>普通架构 ( 1.0版本 )</span>
                </div>
                <p>每月的SD-WAN云启用成本较低（甚至为0）；</p>
                <p>多链路/ISP负载均衡；</p>
                <p>实时流量监控，提高所有WAN应用程序的性能；</p>
                <p>以更好的连接备份，提高灾难恢复（DR）。</p>
              </div>
            </div>
          </el-col>
          <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:8}">
            <div class="module4-item wow slideInUp">
              <div class="conts">
                <div class="title">
                  <img :src="require('@/assets/images/sdwan-module4-2.png')" />
                  <span>POP云架构 ( 2.0版本 )</span>
                </div>
                <p>云网关: 提高云应用的性能和应用程序的可靠性；</p>
                <p>多链路/ISP负载均衡；</p>
                <p>实时流量监控，提高WAN应用的性能；</p>
                <p>以更好的连接备份，提高灾难恢复（DR）。</p>
              </div>
            </div>
          </el-col>
          <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:8}">
            <div class="module4-item wow slideInRight">
              <div class="conts">
                <div class="title">
                  <img :src="require('@/assets/images/sdwan-module4-3.png')" />
                  <span>超级云架构 ( 3.0版本 )</span>
                </div>
                <p>广域网流量主要通过私有骨干网传输，提高网络应用的性能，尤其是实时应用的性能；</p>
                <p>云网关能够提高云应用的性能和可靠性；</p>
                <p>多链路/ISP负载均衡；</p>
                <p>实时流量监控，提高WAN应用的性能；</p>
                <p>以更好的连接备份，提高灾难恢复（DR）；</p>
                
              </div>
            </div>
          </el-col>
        </div>
      </el-col>
    </div>
    <div class="bgbox-white">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="module-title">
          <span>SD-WAN POP节点展示图</span>
        </div>
        <div class="module5-conts">
          <el-col :xs="{span:24}" :sm="{span:16}" :md="{span:16}" :lg="{span:16}">
            <img class="module5-img" :src="require('@/assets/images/sdwan-module5-1.png')" />
          </el-col>
          <el-col :xs="{span:24}" :sm="{span:8}" :md="{span:8}" :lg="{span:8}">
            <div class="info-list">
              <p class="line1">神行者SD-WAN</p>
              <p class="line1">全国POP节点分布图展示</p>
              <p class="line2">全国POP节点范围分布广，覆盖华中、华南、华北、华东区域；</p>
              <p class="line2">使用神行者SD-WAN的用户，可以按需求自由组合POP节点；</p>
              <p class="line2">如果pop节点因故障断开，神行者SD-WAN会自行择优选择，最近的pop节点，保证线路畅通无阻。</p>
            </div>
          </el-col>
        </div>
      </el-col>
    </div>
    <div class="bgbox-white">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="module-title">
          <span>神行者运营实力</span>
        </div>
        <div class="module6-conts">
          <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:24}" :lg="{span:8}" :xl="{span:8}">
            <div class="card wow slideInLeft">
              <img :src="require('@/assets/images/sdwan-module6-1.jpg')" />
              <p>增值电信业务经营许可证</p>
            </div>
          </el-col>
          <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:8}" :xl="{span:8}">
            <div class="card wow slideInUp">
              <img :src="require('@/assets/images/sdwan-module6-2.jpg')" />
              <p>运营商设备进网许可证</p>
            </div>
          </el-col>
          <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:8}" :xl="{span:8}">
            <div class="card wow slideInRight">
              <img :src="require('@/assets/images/sdwan-module6-3.jpg')" />
              <p>计算机信息系统安全专用产品销售许可证</p>
            </div>
          </el-col>
        </div>
      </el-col>
    </div>
    <div class="bgbox-white">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="module-title">
          <span>产品特征</span>
        </div>
        <div class="module7-conts">
          <img :src="require('@/assets/images/sdwan-module7-1.png')" />
        </div>
      </el-col>
    </div>
    <div class="bgbox-white">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="module-title">
          <span>SD-WAN使用场景</span>
        </div>
        <div class="module8-conts wow slideInUp">
          <swiper :options="swiperOptionSdwan">
            <!-- slides -->
            <swiper-slide><img :src="require('@/assets/images/sdwan-module8-1.jpg')" /></swiper-slide>
            <swiper-slide><img :src="require('@/assets/images/sdwan-module8-2.jpg')" /></swiper-slide>
            <swiper-slide><img :src="require('@/assets/images/sdwan-module8-3.jpg')" /></swiper-slide>
            <swiper-slide><img :src="require('@/assets/images/sdwan-module8-4.jpg')" /></swiper-slide>
            <!-- Optional controls -->
            <div class="swiper-pagination swiper-sdwan-pagination"  slot="pagination"></div>
            <div class="swiper-button-prev swiper-sdwan-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next swiper-sdwan-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </el-col>
    </div>
    <div class="bgbox-gray">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="module-title">
          <span>神行者SD-WAN 产品展示</span>
        </div>
        <div class="module9-conts">
          <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:6}" :xl="{span:6}">
            <div class="item wow slideInUp" data-wow-delay="0.1s">
              <div class="card">
                <img :src="require('@/assets/images/sdwan-module9-1.jpg')" />
                <h4>型号：XWAN-M1</h4>
                <div class="infos">
                  <p>使用人数：10个</p>
                  <p>流量压缩：支持</p>
                  <p>网络接口：5个千兆网口</p>
                  <p>加密隧道转发能力：20M</p>
                  <p>隧道session数：1000个</p>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:6}" :xl="{span:6}">
            <div class="item wow slideInUp" data-wow-delay="0.2s">
              <div class="card">
                <img :src="require('@/assets/images/sdwan-module9-2.jpg')" />
                <h4>型号：XWAN-M2</h4>
                <div class="infos">
                  <p>使用人数：20个</p>
                  <p>流量压缩：支持</p>
                  <p>网络接口：5个千兆网口</p>
                  <p>加密隧道转发能力：30M</p>
                  <p>隧道session数：2000个</p>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:6}" :xl="{span:6}">
            <div class="item wow slideInUp" data-wow-delay="0.1s">
              <div class="card">
                <img :src="require('@/assets/images/sdwan-module9-3.jpg')" />
                <h4>型号：XWAN-M3</h4>
                <div class="infos">
                  <p>使用人数：100个</p>
                  <p>流量压缩：支持</p>
                  <p>网络接口：4个千兆网口</p>
                  <p>加密隧道转发能力：50M-100M</p>
                  <p>隧道session数：10000个</p>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:6}" :xl="{span:6}">
            <div class="item wow slideInUp" data-wow-delay="0.2s">
              <div class="card">
                <img :src="require('@/assets/images/sdwan-module9-4.jpg')" />
                <h4>型号：XWAN-W1</h4>
                <div class="infos">
                  <p>使用人数：30个</p>
                  <p>流量压缩：支持</p>
                  <p>网络接口：5个千兆网口</p>
                  <p>双频WIFI：4G/5G扩展CPE</p>
                  <p>加密隧道转发能力：50M</p>
                  <p>隧道session数：4000个</p>
                </div>
              </div>
            </div>
          </el-col>
        </div>
      </el-col>
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOptionSdwan: {
        autoHeight: true,
        slidesPerView: 1,//显示数量
        loop: true,
        autoplay:{
          delay: 5000,
          disableOnInteraction: false//点击切换后 继续自动播放
        },
        pagination: {
          el: '.swiper-sdwan-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-sdwan-button-next',
          prevEl: '.swiper-sdwan-button-prev',
        }
      }
    };
  }
};
</script>
<style lang="scss" scoped>
.bgbox-white {
  padding: 50px 10px;
  overflow: hidden;
  background: #fff;
  box-sizing: border-box;
}
.bgbox-gray {
  padding: 50px 10px;
  overflow: hidden;
  background: #f7f7f7;
  box-sizing: border-box;
}
.the-banner {
  height: 400px;
  background-image: url("../../../assets/images/sdwan-banner1.jpg");
  background-repeat: no-repeat;
  background-position: center;
}
.module-title{
  text-align: center;
  padding-bottom: 40px;
  span{
    display: block;
    font-size: 24px;
    font-weight: bold;
    color: #1f1f1f;
  }
}

.module1-conts{
  p{
    font-size: 16px;
    color: #666;
    margin-bottom: 30px;
  }
  .img-list{
    max-width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    .img-item{
      width: 100%;
      height: 220px;
      overflow: hidden;
      margin-bottom: 20px;
      img{
        display: block;
        height: 100%;
        margin: 0 auto;
      }
    }
  }
}

.module2-conts{
  .line1{
    font-size: 16px;
    color: #0066cc;
  }
  .line2{
    font-size: 14px;
    color: #666666;
    margin-bottom: 16px;
  }
  .card-list{
    width: 100%;
    overflow: hidden;
    padding: 30px 0;
    box-sizing: border-box;
    .item{
      width: 100%;
      padding: 0 10px;
      .card{
        width: 100%;
        max-width: 220px;
        min-height: 150px;
        margin: 0 auto 10px;
        background: #fafafa;
        .card-header{
          width: 100%;
          height: 40px;
          background: #f5f5f5;
          text-align: center;
          line-height: 40px;
          font-size: 16px;
          color: #4c4c4c;
        }
        .card-body{
          width:100%;
          padding: 10px;
          box-sizing: border-box;
          font-size: 14px;
          color: #4c4c4c;
        }
      }
    }
  }
  .img-view{
    width: 100%;
    overflow: hidden;
    padding: 30px 0;
    box-sizing: border-box;
    .module2-img{
      display: block;
      width: 100%;
      max-width: 510px;
      margin: 0 auto;
    }
  }
}

.module3-conts{
  p{
    font-size: 16px;
    color: #666666;
    margin-bottom: 20px;
    span{
      color: #0066cc;
    }
  }
  .img-box{
    width: 100%;
    padding-top: 20px;
    img{
      display: block;
      width: 80%;
      max-width: 838px;
      min-width: 300px;
      margin: 0 auto;
    }
  }
}

.module4-conts{
  width: 100%;
  overflow: hidden;
  .module4-item{
    max-width: 400px;
    margin: 0 auto;
    padding: 10px;
    box-sizing: border-box;
    .conts{
      border: 1px solid #e6e6e6;
      padding: 20px;
      box-sizing: border-box;
      min-height: 420px;
      transition: all 0.3s ease-in;
      &:hover{
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        transform: translate3d(0,-2px,0);
        background: rgba(124, 215, 243, 0.2);
      }
      .title{
        height: 180px;
        text-align: center;
        padding-top: 20px;
        box-sizing: border-box;
        img{
          margin-bottom: 20px;
        }
        span{
          display: block;
          font-size: 20px;
          color: #1f1f1f;
        }
      }
      p{
        font-size: 14px;
        color: #666;
        line-height: 24px;
      }
    }
  }
}

.module5-conts{
  overflow: hidden;
  .module5-img{
    width: 100%;
  }
  .info-list{
    width: 100%;
    padding-top: 200px;
    box-sizing: border-box;
    .line1{
      font-size: 16px;
      color: #0066cc;
      &:nth-child(2){
        margin-bottom: 20px;
      }
    }
    .line2{
      font-size: 16px;
      color: #666666;
    }
  }
}

.module6-conts{
  overflow: hidden;
  .card{
    width: 100%;
    text-align: center;
    padding-bottom: 20px;
    box-sizing: border-box;
    img{
      display: block;
      max-width: 100%;
      margin: 0 auto;
    }
    p{
      font-size: 16px;
      color: #1f1f1f;
      line-height: 30px;
    }
  }
}

.module7-conts{
  width: 100%;
  img{
    display: block;
    width: 90%;
    max-width: 960px;
    min-width: 300px;
    margin: 0 auto;
  }
}

.module8-conts{
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  .swiper-container {
    width: 100%;
  }
  .swiper-slide img{
    width: 100%;
  }
  .swiper-button-prev,.swiper-button-next{
    outline: none;
    height: 30px;
  }
}

.module9-conts{
  overflow: hidden;
  width: 100%;
  .item{
    padding: 10px;
    .card{
      width: 100%;
      max-width: 320px;
      min-height: 360px;
      background: #fff;
      padding: 10px 20px;
      box-sizing: border-box;
      margin: 0 auto;
      transition: all 0.3s ease-in;
      &:hover{
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        transform: translate3d(0,-2px,0);
      }
      img{
        display: block;
        width: 100%;
        max-width: 200px;
        margin: 0 auto;
      }
      h4{
        font-size: 18px;
        color: #1f1f1f;
        text-align: center;
        margin-bottom: 20px;
      }
      .infos{
        width: 200px;
        margin: 0 auto;
        p{
          font-size: 14px;
          color: #666666;
        }
      }
    }
  }
}

// 移动端css
@media screen and (max-width: 767px) {
  .the-banner{
    height: 260px;
    background-image: url("../../../assets/images/sdwan-banner2.jpg");
  }
  .module4-conts{
    .module4-item{
      padding: 10px 0;
      .conts{
        padding: 10px;
      }
    }
  }
  .module5-conts{
    .info-list{
      padding-top: 0;
    }
  }
}
</style>